class CustomStoryCardSlideshow extends HTMLElement {
  connectedCallback() {
    this._slides = Array.from(this.querySelectorAll(':scope > img'));
    if (this._slides.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    this._interval = parseInt(this.getAttribute('interval'), 10) || 4000;
    this._index = this._slides.findIndex((s) => s.classList.contains('is-active'));
    if (this._index < 0) {
      this._index = 0;
      this._slides[0].classList.add('is-active');
    }

    this._visible = true;
    this._observer = new IntersectionObserver(
      ([entry]) => {
        this._visible = entry.isIntersecting;
        this._visible ? this._start() : this._stop();
      },
      { threshold: 0.1 }
    );
    this._observer.observe(this);

    document.addEventListener('visibilitychange', this._onVisibilityChange);
  }

  disconnectedCallback() {
    this._stop();
    if (this._observer) this._observer.disconnect();
    document.removeEventListener('visibilitychange', this._onVisibilityChange);
  }

  _onVisibilityChange = () => {
    document.hidden || !this._visible ? this._stop() : this._start();
  };

  _start() {
    if (this._timer || !this._slides || this._slides.length < 2) return;
    this._timer = window.setInterval(() => this._advance(), this._interval);
  }

  _stop() {
    if (this._timer) {
      window.clearInterval(this._timer);
      this._timer = null;
    }
  }

  _advance() {
    this._slides[this._index].classList.remove('is-active');
    this._index = (this._index + 1) % this._slides.length;
    this._slides[this._index].classList.add('is-active');
  }
}

if (!customElements.get('custom-story-card-slideshow')) {
  customElements.define('custom-story-card-slideshow', CustomStoryCardSlideshow);
}
